import {inject, Injectable} from '@angular/core';
import {
  GlobalSplashArtLoaderService
} from 'src/app/shared/services/global-splashart-loader/global-splashart-loader.service';
import {GlobalSnackbarService} from 'src/app/shared/services/global-snackbar/global-snackbar.service';
import {FV_SNACKBAR_COLOR, FV_SNACKBAR_DISPLAY} from '@discocil/fv-components';
import {PaymentFeedback} from '@features/payment/domain/ports/ui/feedback.port';
import {FV_SNACKBAR_TIME_BEFORE_CLOSE} from 'src/app/config/global-snackbar.config';

@Injectable({providedIn: 'root'})
export class PaymentFeedbackPresenter implements PaymentFeedback {
  private readonly snackbar = inject(GlobalSnackbarService);
  private readonly splash = inject(GlobalSplashArtLoaderService);
  private loaderRef: { close: () => void } | null = null;

  private readonly ERROR_SNACKBAR_CONFIG = {
    message: '',
    hasIconClose: false,
    color: FV_SNACKBAR_COLOR.red,
    display: FV_SNACKBAR_DISPLAY.inline,
    hasIcon: true,
    timeBeforeClose: FV_SNACKBAR_TIME_BEFORE_CLOSE.normal,
  };

  public showLoading(loadingTextKey?: string): void {
    if (this.loaderRef) {
      return;
    }

    this.loaderRef = this.splash.open({
      loadingTexts: [loadingTextKey ?? 'fv_modal.payment_loader.msg'],
      isShowingRandomTexts: false,
    });
  }

  public hideLoading(): void {
    this.loaderRef?.close?.();
    this.splash.close();
    this.loaderRef = null;
  }

  public showError(errorTitleKey: string): void {
    this.hideLoading();
    this.snackbar.open({
      ...this.ERROR_SNACKBAR_CONFIG,
      title: errorTitleKey,
    });
  }
}
